import React, { useState } from "react";
import "../DoctorConsole.scss";
import PrescriptionCard from "../../../components/PrescriptionCard/PrescriptionCard";
import OpConsultation from "../../../components/OpConsultation/OpConsultation";
import Wellness from "../../../components/Wellness/Wellness";
import RecordArtifact from "../../../components/RecordArtifact/RecordArtifact";
import DischargeSummary from "../../../components/DischargeSummary/DischargeSummary";
import ImmunizationRecord from "../../../components/ImmunizationRecord/ImmunizationRecord";
import ReportingChart from "../../../components/ReportingChart/ReportingChart";
import { Typography, IconButton } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const RecordsPagination = ({ records, collapseByDefault }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 1; // Number of records to show per page

  // Calculate total number of pages
  const totalPages = Math.ceil(records.length / recordsPerPage);

  // Get records for the current page
  const currentRecords = records.slice(
    (currentPage - 1) * recordsPerPage,
    currentPage * recordsPerPage
  );

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePrevious = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  return (
    <div>
      <div>
        {currentRecords.map((record, index) => (
          <div key={index}>
            {record.sectionName === "Prescription" && (
              <PrescriptionCard prescriptionData={record.sectionData} collapseByDefault={collapseByDefault} />
            )}
            {record.sectionName === "OP Consultation" && (
              <OpConsultation opConsultationData={record.sectionData} collapseByDefault={collapseByDefault} />
            )}
            {record.sectionName === "Wellness Record" && (
              <Wellness wellnessData={record.sectionData} collapseByDefault={collapseByDefault} />
            )}
            {record.sectionName === "Record artifact" && (
              <RecordArtifact recordArtifactData={record.sectionData} collapseByDefault={collapseByDefault} />
            )}
            {record.sectionName === "Discharge Summary" && (
              <DischargeSummary dischargeSummaryData={record.sectionData} collapseByDefault={collapseByDefault} />
            )}
            {record.sectionName === "Immunization Record" && (
              <ImmunizationRecord immunizationData={record.sectionData} collapseByDefault={collapseByDefault} />
            )}
            {record.sectionName === "Diagnostic Report" && (
              <ReportingChart diagnosticData={record.sectionData} collapseByDefault={collapseByDefault} />
            )}
            {record.sectionName === "Display not found" && (
              <h1 className="console-heading" style={{ textAlign: "center" }}>
                There is some issue
              </h1>
            )}
          </div>
        ))}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          justifyContent: "space-evenly",
        }}
      >
        <IconButton onClick={handlePrevious} disabled={currentPage === 1}>
          <ArrowBackIosIcon />
        </IconButton>
        <Typography>
          {currentPage}/{totalPages}
        </Typography>
        <IconButton onClick={handleNext} disabled={currentPage === totalPages}>
          <ArrowForwardIosIcon />
        </IconButton>
      </div>
    </div>
  );
};

export default RecordsPagination;
